import { Component } from '@angular/core';

import { BtnActionComponent } from '../btn-action/btn-action.component';

@Component({
    selector: 'aa-btn-action-tertiary',
    templateUrl: '../btn-action/btn-action.component.html',
    styleUrls: [
        '../btn-action/btn-action.component.scss',
        './btn-action-tertiary.component.scss'
    ],
    standalone: false
})
export class BtnActionTertiaryComponent extends BtnActionComponent
{
    constructor ()
    {
        super();
    }
}
